import React, { useState } from 'react';
import './MathCounter.css';

const MathCounter = () => {
    const [firstNumber, setFirstNumber] = useState(1);
    const [secondNumber, setSecondNumber] = useState(1);
    const [operator, setOperator] = useState('+');

    const calculateResult = () => {
        switch (operator) {
            case '+':
                return firstNumber + secondNumber;
            case '-':
                return firstNumber - secondNumber;
            case 'x':
                return firstNumber * secondNumber;
            case '/':
                return secondNumber !== 0 ? firstNumber / secondNumber : 'Error';
            default:
                return 0;
        }
    };

    const operators = ['+', '-', 'x', '/'];

    return (
        <div className="math-counter">
            <div className="math-expression">
                <input
                    type="number"
                    value={firstNumber}
                    onChange={(e) => setFirstNumber(Number(e.target.value))}
                    className="number-input"
                />
                <select
                    value={operator}
                    onChange={(e) => setOperator(e.target.value)}
                    className="operator-select"
                >
                    {operators.map(op => (
                        <option key={op} value={op}>{op}</option>
                    ))}
                </select>
                <input
                    type="number"
                    value={secondNumber}
                    onChange={(e) => setSecondNumber(Number(e.target.value))}
                    className="number-input"
                />
                <span className="equals">=</span>
                <span className="result">{calculateResult()}</span>
            </div>
        </div>
    );
};

export default MathCounter; 